import { Alert, Stack } from "@mui/material";
import React from "react";
import AppContactDetailCard from "../AppContactDetailCard";
import AppMobileInfoCard from "../AppMobileInfoCard";
import MobileAppActionButtons from "../MobileAppActionButtons";
import { useDispatch } from "react-redux";

const InactiveIconContent = ({
  patientId,
  patientName,
  patientContactNumber,
  patientEmail,
  firstLogin,
  lastAppOpened,
  osVersion,
  appVersion,
  ever_pain_logged,
  lastReadingTime,
  openChangePasswordModalHandler,
  subtitle,
  resendCredentialsHandler,
}) => {
  return (
    <Stack gap="24px">
      <MobileAppActionButtons
        resendCredentialsHandler={resendCredentialsHandler}
        openChangePasswordModalHandler={openChangePasswordModalHandler}
      />

      <Alert severity="warning">{subtitle}</Alert>

      <AppMobileInfoCard
        firstLogin={firstLogin}
        lastAppOpened={lastAppOpened}
        appVersion={appVersion}
        osVersion={osVersion}
        lastReadingTime={lastReadingTime}
      />

      <AppContactDetailCard
        patientId={patientId}
        patientContactNumber={patientContactNumber}
        patientEmail={patientEmail}
        status="inactive"
      />
    </Stack>
  );
};

export default InactiveIconContent;
